export default "__VITE_ASSET__Brh5Lu4F__"